import { Component, inject } from '@angular/core';
import { Auth, signInWithEmailAndPassword } from '@angular/fire/auth';
import { FormsModule } from '@angular/forms';

import { environment } from '../../environments/environment';
import { AuthGateService } from '../services/auth-gate.service';
@Component({
    selector: 'app-login',
    imports: [FormsModule],
    templateUrl: './login.component.html',
    styleUrl: './login.component.css'
})
export class LoginComponent {
  private auth = inject(Auth);
  private authGate = inject(AuthGateService);

  email: string = '';
  password: string = '';
  environment: string;
  isLoading: boolean = false;
  errorMessage: string | null = null;

  constructor() {
    this.environment = `${environment.name} - ${environment.version}`;
  }

  get notAuthorized(): boolean {
    return this.authGate.notAuthorized();
  }
  
  async loginUser() {
    if (this.isLoading) return;

    this.isLoading = true;
    this.errorMessage = null;
    this.authGate.notAuthorized.set(false);

    try {
      const userCredential = await signInWithEmailAndPassword(this.auth, this.email, this.password);
      console.log('Logged in');
    } catch (error) {
      console.error('Error logging in', error);
      this.errorMessage = 'Email or password is incorrect';
    } finally {
      this.isLoading = false;
    }
  }
}
